import { useApi } from "../api";
import { ProfileAvatarUploader } from "./ProfileAvatarUploader";
import { Utils } from '../utils';
import { useEffect, useState } from "react";
import { ICargo } from "../interfaces";

export type HeaderProfileProps = {
    avator?: string;
    nickname?: string;
    simpleCode?: string;
}
export const HeaderProfile = (props: HeaderProfileProps) => {
    const storage = JSON.parse(JSON.stringify(localStorage));
    const projectCode = JSON.parse(storage['team'])[0].split('_')[1] || 'SAI'
    const api = useApi(projectCode)
    const [avator, setAvator] = useState<string|null>(null)

    useEffect(() => {
        const avatorUrl = props.avator
        ? props.avator.startsWith('http') ? props.avator : Utils().normalizeImagePath(props.avator, projectCode)
        : require('../assets/img/nopic.png')
        setAvator(avatorUrl)
    }, [projectCode, props.avator])
    return (
        <>
            <div className="bg1 py-3">
                {
                    <ProfileAvatarUploader image={avator} onUploaded={(cargo: ICargo) => {
                        if (cargo.returnCode === '000000') {
                            api.updateAvator(`https://file.sup.me.uk/${projectCode.toLocaleLowerCase()}/${cargo.info['file']}`)
                            setAvator(Utils().normalizeImagePath(cargo.info['file'], projectCode))
                        }
                    }}></ProfileAvatarUploader>
                }
                <div className="d-flex flex-column">
                    <div className="peot font-weight-bold">{props.nickname}</div>
                    <div className="peot">{props.simpleCode}</div>
                </div>
            </div>
        </>
    )
}